<template>
  <div class="page-container h-full">
    <form-page ref="formPage">
      <template #form-bottom>
        <slot name="form-bottom" />
      </template>
    </form-page>
  </div>
</template>
<script>
import FormPage from "@/components/TkCommonPage/pages/FormPage.vue"

export default {
  name: "Index",
  components: {
    FormPage
  },
  props: {
    pageName: {
      type: String,
      default: "数据表格"
    },
    bgPath: { // 请求地址
      type: String,
      required: true
    },
    webPath: { // 跳转地址
      type: String,
      required: true
    },
    searchItems: { // 搜索框配置
      type: Array,
      default: () => []
    },
    columns: { // 表格列配置
      type: Array,
      default: () => []
    },
    formItems: { // 表单配置
      type: Array,
      default: () => []
    },
    dTableConfig: { // 子表配置
      type: Array,
      default: () => {
        return []
      }
    },
    editorItems: { // 富文本配置
      type: Array,
      default: () => []
    },
    pageType: { // 页面类型 commonPage - 普通页面 hdPage - 主子表页面 editorPage 编辑
      type: String,
      default: "commonPage"
    },
    useStore: { // 是否使用门店
      type: Boolean,
      default: false
    },
    // 表格操作项
    tableOptions: {
      type: Array,
      default: () => ['add', 'edit', 'details', 'delete', 'filter']
    },
    formOptions: {
      type: Array,
      default: () => ["add", "copy", "edit", "details", "save", "cancel"]
    }
  },
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 界面模式  info - 信息页, list - 列表页
      viewMode: 'list',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: 'list',
      // 表单
      formData: {
        head: {},
        body: {}
      },
      formItemsData: [], // 初始化为空数组，将在 mounted 中填充
      activeId: 0,
      dTableKeyNum: 0
    }
  },
  mounted() {
    this.formItemsData = [...this.formItems]
  },
  methods: {
    /**
     * 更新表单相
     * @param refCode
     */
    updateFormItem(refCode) {
      this.$refs.formPage.handleFormItemUpdate(refCode)
    },
    /**
     * 更新表单
     * @param key
     * @param value
     */
    updateFormData(key, value) {
      this.$refs.formPage.updateFormData(key, value)
    },
    updateTitleData(key, value) {
      this.$refs.formPage.updateTitleData(key, value)
    },
    /**
     * 更新子表
     * @param line
     * @param dName
     * @param key
     * @param value
     */
    updateDTableData(line, dName, key, value) {
      console.log(this.formData.body)

      this.$set(this.formData.body[dName][line], key, value)
    },
    /**
     * 更新表格
     */
    resetFormData() {
      this.formData = {
        head: {},
        body: {}
      }
      this.dTableConfig.forEach(item => {
        this.formData.body[item.key] = []
      })
      this.activeId = 0
    },
    disabledItem(code, key) {
      // 直接操作本地数据，避免依赖 refs
      if (!this.formItemsData || this.formItemsData.length === 0) return

      this.formItemsData[0].items.forEach(e => {
        if (e.code === code) {
          // 使用 $set 确保响应式更新
          this.$set(e.config, 'disabled', key)
          console.log(e)
        }
      })

      // 立即更新到子组件
      this.$nextTick(() => {
        if (this.$refs.formPage && this.$refs.formPage.pageData) {
          this.$emit('update-item-disabled', [...this.formItemsData])
          // this.$refs.formPage.pageData.formItems = [...this.formItemsData]
        }
      })
    },
    configItem(code, key, configCode = 'rules') {
      // 直接操作本地数据，避免依赖 refs
      if (!this.formItemsData || this.formItemsData.length === 0) return

      this.formItemsData[0].items.forEach(e => {
        if (e.code === code) {
          // 使用 $set 确保响应式更新
          this.$set(e.config, configCode, key)
        }
      })

      // 立即更新到子组件
      this.$nextTick(() => {
        if (this.$refs.formPage && this.$refs.formPage.pageData) {
          this.$emit('update-item-disabled', [...this.formItemsData])
          // this.$refs.formPage.pageData.formItems = [...this.formItemsData]
        }
      })
    },
    /**
     * 获取表单项配置
     * @param code 字段代码
     * @returns 表单项配置对象
     */
    getFormItemConfig(code) {
      if (!this.$refs.formPage) return null

      const formItems = this.$refs.formPage.pageData?.formItems?.[0]?.items
      if (!formItems) return null

      return formItems.find(item => item.code === code)?.config
    },
    /**
     * 触发特定字段的重新查询
     * @param {String} code - 字段代码
     */
    triggerFieldSearch(code) {
      if (this.$refs.form) {
        this.$refs.form.triggerFieldSearch(code)
      }
    },
    /**
     * 更新表单项配置
     * @param {String} code - 字段代码
     * @param {Object} newConfig - 新的配置项
     */
    updateFormItemConfig(code, newConfig) {
      if (!this.formItemsData || this.formItemsData.length === 0) return
      this.formItemsData[0].items.forEach(item => {
        if (item.code === code) {
          // 合并新旧配置
          item.config = {
            ...item.config,
            ...newConfig
          }

          // 通知子组件更新
          this.$nextTick(() => {
            this.$emit('update-item-disabled', [...this.formItemsData])
          })
        }
      })
    }

  },
  provide() {
    return {
      pageData: this,
      disabledItem: this.disabledItem,
      getFormItemConfig: this.getFormItemConfig
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 16px;
}
</style>
